module.exports = __webpack_public_path__ + "resources/img/logo_hyosungItx.42e6e491eab82e42d2ec5dce6bd8b3dc.png";